import { render, staticRenderFns } from "./CadastroCabecalhoLaudo.vue?vue&type=template&id=728de144&"
import script from "./CadastroCabecalhoLaudo.vue?vue&type=script&lang=js&"
export * from "./CadastroCabecalhoLaudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports